import { Status } from "@lib/types/entity-status.enum";

export interface ContactFormData {
  contactId?: number;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
}

export interface Contact {
  contactID?: number;
  contactType: ContactType;
  contactName: string;
  contactEmail: string;
  contactPhone?: string;
  status?: Status;
  createdDate?: string;
  lastModifiedDate?: string;
  createdBy?: string;
  modifiedBy?: string;
  isPrimary: boolean;
}

export enum ContactType {
  "BUSINESS" = "Business",
  "BILLING" = "Billing",
  "TECHNICAL" = "Technical",
  "SUPPORT" = "Support",
}

export interface ContactRequest {
  contactType: string;
  contactName?: string;
  contactEmail?: string;
  contactPhone?: string;
  isPrimary?: boolean;
}

export interface ContactFormValue {
  contactName: string;
  contactEmail: string;
  contactPhone: string;
}
